export default __webpack_public_path__ + "assets/images/Star Badge-9a197ee58e91c56d8607b19b656a253d.svg";